var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGotoProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5838 6.94149L10.6336 1.99132C10.1781 1.53578 10.1781 0.7972 10.6336 0.341657C11.0892 -0.113886 11.8278 -0.113886 12.2833 0.341657L18.0582 6.11653C18.5138 6.57214 18.5138 7.31084 18.0582 7.76645L12.2833 13.5413C11.8278 13.9969 11.0892 13.9969 10.6336 13.5413C10.1781 13.0858 10.1781 12.3472 10.6336 11.8917L15.5838 6.94149Z",
    fill: "#52525B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666992 7C0.666992 6.35567 1.18933 5.83333 1.83366 5.83333H16.417C17.0613 5.83333 17.5837 6.35567 17.5837 7C17.5837 7.64433 17.0613 8.16667 16.417 8.16667H1.83366C1.18933 8.16667 0.666992 7.64433 0.666992 7Z",
    fill: "#52525B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotoProfile);
export default __webpack_public_path__ + "static/media/GotoProfile.2493bc21b6bcef3b83de0f159d4950c9.svg";
export { ForwardRef as ReactComponent };